export enum EncounterNotesType {
  ENCOUNTER_NOTE = "encounterNote",
  ENCOUNTER_NOTES = "encounterNotes",
  CLIENT_SUMMARY_NOTE = "encounterClientSummary",
  NOTES = "notes",
}
